import { jsx as _jsx } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import { FieldWrapper } from '@ciam/ui';
export function FormInputController({ name, label, component: Component, control, errors, ...props }) {
    const hasError = !!errors[name];
    const state = hasError ? 'error' : 'default';
    return (_jsx(FieldWrapper, { label: label || '', state: state, errorMessage: errors[name]?.message, required: true, children: _jsx(Controller, { name: name, control: control, render: ({ field }) => _jsx(Component, { ...props, ...field, state: state }) }) }));
}
//# sourceMappingURL=form-input-controller.js.map